import { Injectable } from '@angular/core';

export interface Theme {
  title: string;
  theme: string;
  productName: string;
  appId: string; // used for consent
  code: string; // used for consent
}

export const THEMES: Theme[] = [
  { title: 'Cardihab', theme: 'theme-smartcr', productName: 'SmartCR', code: 'smartcr', appId: 'com.cardihab.app' },
  { title: 'Cardihab', theme: 'theme-smarthf', productName: 'SmartHF', code: 'smarthf', appId: 'com.cardihab.smarthf' },
  { title: 'QCG', theme: 'theme-qcg', productName: 'QCG Care', code: 'qcg', appId: 'au.com.qcg.rehab' },
  { title: 'Medibank', theme: 'theme-medibank', productName: 'Heart Health at Home', code: 'medibankcr', appId: 'au.com.medibank.hearthealth' },
  { title: 'Teladoc', theme: 'theme-teladoc', productName: 'Teladoc Health - Heart Coach', code: 'teladoccr', appId: 'au.com.teladoc.heartcoach' },
];


@Injectable({
  providedIn: 'root'
})
export class BrandService {
  brand: string | undefined;

  constructor() { }

  get() {
    return this.brand;
  }

  set(value: string) {
    this.brand = value;
  }

  getProductName(): string {
    const matchingTheme = THEMES.find(theme => theme.theme === this.brand);
    return matchingTheme?.productName || 'This app';
  }

  getAppId(): string  {
    const matchingTheme = THEMES.find(theme => theme.theme === this.brand);
    return matchingTheme?.appId || '';
  }

  getOrganisation(): string {
    const matchingTheme = THEMES.find(theme => theme.theme === this.brand);
    return matchingTheme?.title || 'Cardihab';
  }

  getCode(): string {
    const matchingTheme = THEMES.find(theme => theme.theme === this.brand);
    return matchingTheme?.code || 'default';
  }
}
